/**
 * Custom error class to mark errors that have already been reported to Sentry.
 * This prevents duplicate error reports when errors bubble up through multiple
 * error boundaries or error handlers.
 */
export class ReportedError extends Error {
  readonly isReported = true;

  public originalError?: Error;

  constructor(message: string, originalError?: Error) {
    super(message);
    this.name = "ReportedError";
    this.originalError = originalError;

    // Maintain proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ReportedError);
    }

    // If there's an original error, preserve its stack trace
    if (originalError?.stack) {
      this.stack = originalError.stack;
    }
  }
}

/**
 * Type guard to check if an error has already been reported to Sentry
 */
export function isReportedError(error: Error): boolean {
  return "isReported" in error && (error as any).isReported === true;
}
